import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Modal } from 'synfrastructure';
import clone from 'lodash/clone';
import cloneDeep from 'lodash/cloneDeep';
import numeral from 'numeral';
import snakeCase from 'lodash/snakeCase';

import { registerForClass } from './redux/actions';
import { selectActiveGolfSchool } from './redux/selectors';
import { hasMsAdminAccess } from '../../redux/selectors';
import { pushToast } from '../../../redux/actions';
import formatClassDateRange from './formatClassDateRange';

import ClassRegistrationModal from './class-registration/ClassRegistrationModal';
import getDecodedToken from '../../../common/auth/utils/getDecodedToken';
import Icon from '../../../common/icons/Icon';
import Loading from '../../../common/components/Loading';
import { reportTrainingPurchase, sendIntercomEvent } from '../../../common/events';
import Carousel from './carousel/Carousel';

class GolfSchoolPage extends Component {
  state = {
    loading: true,
    modalVisible: false,
  };

  componentDidMount() {
    const { history, hasMsAdminAccess, school } = this.props;

    if (school) {
      if (school.name === 'Movement Specialist Schools' && !hasMsAdminAccess) {
        history.replace('/subscription/coaching/golf-schools');
      }
      this.setState({ loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { history, hasMsAdminAccess, school } = this.props;
    if (!school && nextProps.school && nextProps.school.name === 'Movement Specialist Schools' && !hasMsAdminAccess) {
      history.replace('/subscription/coaching/golf-schools');
    } else if (school) {
      this.setState({ loading: false });
    }
  }

  handleDownloadEvent = () => {
    const { school } = this.props;
    sendIntercomEvent(`download_${snakeCase(school.name)}_pdf`);
  };

  handleToggleModal = classEntity => () => {
    const { school } = this.props;
    !this.state.modalVisible && sendIntercomEvent(`view_${snakeCase(school.name)}_purchase_modal`);
    this.setState(state => {
      return {
        modalActiveClass: classEntity,
        modalVisible: !state.modalVisible,
      };
    });
  };

  handleSubmit = values => {
    const { dispatch, school } = this.props;
    const { modalActiveClass } = this.state;
    const submitValues = cloneDeep(values);

    submitValues.message = submitValues.message.trim();

    return dispatch(registerForClass(getDecodedToken().sub, modalActiveClass.id, submitValues)).then(action => {
      if (!action.response.ok) {
        this.props.dispatch(
          pushToast({
            message: 'There was a problem while submitting your request.',
            status: 'error',
          })
        );
      } else {
        reportTrainingPurchase({
          gaEventLabel: 'Schools',
          intercomEventName: `purchased_${snakeCase(school.name)}`,
          intercomEventData: {
            start_date: modalActiveClass.start_date,
          },
        });
      }
    });
  };

  renderHero = () => {
    const { school } = this.props;

    const priceFormat = school.price % 100 ? '$0,0.00' : '$0,0';

    return (
      <div className="gs-page__hero__wrapper" style={{ backgroundImage: `url(${school.image_url})` }}>
        <div className="container">
          <div className="gs-page__hero">
            <Link className="gs__back" to={`/subscription/coaching/golf-schools`}>
              <span className="button__back-button">
                <Icon icon="BackArrow" />Back to Golf Schools
              </span>
            </Link>
            <h1>{school.name}</h1>
            <h3>
              <span>{`${school.days} day${school.days !== 1 ? 's' : ''}`}</span>
              <span>{`Cost: ${numeral(school.price / 100).format(priceFormat)}`}</span>
              {/* <span className="discount">(August Special: 10% discount)</span> */}
            </h3>
            <div className="gs-page__hero__button">
              {school.file_url && (
                <a
                  className="button button--icon button--theme--inverse"
                  href={school.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={this.handleDownloadEvent}
                >
                  <Icon icon="Download" />
                  Download Itinerary
                </a>
              )}
            </div>
            {school.description && school.description.split('\n').map((description, i) => <p key={i}>{description}</p>)}
          </div>
        </div>
      </div>
    );
  };

  renderQuotation = () => {
    const { school } = this.props;

    return (
      school.quotation.text && (
        <div className="gs-page__quote__wrapper">
          <div className="gs-page__quote">
            <Icon icon="QuoteLeft" />
            <div className="text">
              &ldquo;{school.quotation.text}&rdquo;
              <p className="text">- {school.quotation.source}</p>
            </div>

            <Icon icon="QuoteRight" />
          </div>
        </div>
      )
    );
  };

  renderClassOutcomes = () => {
    const { school } = this.props;

    return (
      <div className="gs-page__outcomes">
        <h2>School Outcomes</h2>
        <ol>
          {school.highlights.school_outcomes.map((outcome, index) => (
            <li key={index}>
              <Icon icon="CheckmarkCircle" className="icon--small" />
              {outcome}
            </li>
          ))}
        </ol>
      </div>
    );
  };

  renderUpcomingDates = () => {
    const { school } = this.props;

    return (
      <div className="gs-page__upcoming">
        <h2>{school.name}</h2>
        <h4>Upcoming Dates</h4>
        <div className="gs-page__upcoming__dates">
          {school.classes.length ? (
            clone(school.classes)
              .sort((a, b) => (a.start_date > b.start_date ? 1 : -1))
              .map((classEntity, index) => (
                <div key={index}>
                  {this.renderClassDateRange(classEntity.start_date, school.days)}
                  {this.renderPurchaseButton(classEntity)}
                </div>
              ))
          ) : (
            <div>There are no upcoming classes at this time.</div>
          )}
        </div>
      </div>
    );
  };

  renderClassDateRange = (startDate, days) => {
    return <div className="date-ranges">{formatClassDateRange(startDate, days)}</div>;
  };

  renderPurchaseButton = classEntity => {
    const { userClasses } = this.props;

    if (userClasses.find(userClass => userClass.get('id') === classEntity.id)) {
      return (
        <button className="button" disabled>
          Already registered!
        </button>
      );
    }

    const returnValues = [];

    if (classEntity.open_spots > 0 && classEntity.open_spots < 5) {
      returnValues.push(
        <span className="spots-remaining" key="spots-remaining">
          Only {classEntity.open_spots} spot{classEntity.open_spots > 1 ? 's' : ''} left!
        </span>
      );
    }

    if (classEntity.open_spots === 0) {
      returnValues.push(
        <button key="soldoutbutton" className="button" type="button" disabled>
          Sold Out!
        </button>
      );
    } else {
      returnValues.push(
        <button key="signupbutton" className="button" type="button" onClick={this.handleToggleModal(classEntity)}>
          Purchase
        </button>
      );
    }

    return <div className="purchase-button">{returnValues}</div>;
  };

  render() {
    const { school } = this.props;
    const { loading, modalActiveClass, modalVisible } = this.state;

    if (!school || loading) {
      return <Loading />;
    }
    return (
      <div className="gs-page">
        {modalVisible && (
          <Modal
            isVisible
            onClose={this.handleToggleModal(null)}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <ClassRegistrationModal
              classEntity={modalActiveClass}
              onCancel={this.handleToggleModal(null)}
              onSubmit={this.handleSubmit}
              school={school}
            />
          </Modal>
        )}
        {this.renderHero()}
        {this.renderQuotation()}
        <div className="container">
          <div className="gs-page__body">
            <div>
              {this.renderClassOutcomes()}
              <Carousel />
            </div>
            {this.renderUpcomingDates()}
          </div>
        </div>
        <div className="container">
          <div className="gs-page__cta">
            Need some additional help with your swing? Book an{' '}
            <Link to="/subscription/coaching/online-follow-up">Online Training Session</Link> with Tathata today!
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  hasMsAdminAccess: hasMsAdminAccess(state),
  school: selectActiveGolfSchool(state, props.match.params.schoolId),
  userClasses: state.subscription.user.getIn(['data', 'classes']),
});

export default connect(mapStateToProps)(GolfSchoolPage);



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/GolfSchoolPage.js